import { Persistor } from 'redux-persist'
import { REDUX_PERSIST_CONSTANTS } from '../constants'
import { ApiValidationError } from '../../types'

// Function to add or update parameters in the URL
export function addParamToURL(paramName: string, paramValue: string): void {
  const url = new URL(window.location.href)
  const params = new URLSearchParams(url.search)
  params.set(paramName, paramValue)
  url.search = params.toString()
  window.history.pushState({ path: url.href }, '', url.href)
}

// Function to get the value of a parameter from the URL
export function getParamFromURL(paramName: string): string | null {
  const url = new URL(window.location.href)
  const params = new URLSearchParams(url.search)
  return params.get(paramName)
}

export const preserveTableColumn = (persist: Persistor) => {
  const root = localStorage.getItem(`persist:${REDUX_PERSIST_CONSTANTS.ROOT}`)

  if (!root) return

  try {
    const parsed = JSON.parse(root)

    const onlyTableColumn = {
      tableColumn: parsed.tableColumn || '{}',
    }
    persist.purge().then(() => {
      localStorage.setItem(
        `${REDUX_PERSIST_CONSTANTS.PERSIST}:${REDUX_PERSIST_CONSTANTS.ROOT}`,
        JSON.stringify(onlyTableColumn)
      )
    })
  } catch (err) {
    console.error('Error preserving tableColumn:', err)
  }
}

type ValidParamValue = boolean | string | number | null | undefined

export const validateApiParams = <T extends Record<string, ValidParamValue>>(
  params: T,
  options: {
    endpoint: string
    method: string
  }
): void => {
  const invalidFields: string[] = []

  const isInvalid = (value: ValidParamValue): boolean =>
    value === undefined ||
    value === null ||
    value === '' ||
    (typeof value === 'string' && !value.trim()) ||
    (typeof value === 'number' && Number.isNaN(value))

  for (const [field, value] of Object.entries(params)) {
    if (isInvalid(value)) {
      invalidFields.push(field)
    }
  }

  if (invalidFields.length > 0) {
    const err = new Error(
      `Invalid API endpoint: ${options.endpoint}`
    ) as ApiValidationError

    err.name = 'ApiValidationError'

    throw err
  }
}
